import { render, staticRenderFns } from "./AIUserMessage.vue?vue&type=template&id=c07244fe&scoped=true"
import script from "./AIUserMessage.vue?vue&type=script&lang=js"
export * from "./AIUserMessage.vue?vue&type=script&lang=js"
import style0 from "./AIUserMessage.vue?vue&type=style&index=0&id=c07244fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07244fe",
  null
  
)

export default component.exports